// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SearchComponents = require("../../../reason/clients/components/SearchComponents.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ClientNeedsPageRelayFilters = require("./ClientNeedsPageRelayFilters.bs.js");
let ClientNeedsPageRelayQueryParams = require("./ClientNeedsPageRelayQueryParams.bs.js");

function ClientNeedsPageRelayFiltersDesktopMenu(props) {
  let refetch = props.refetch;
  let match = ClientNeedsPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "md",
    alignItems: "center",
    flexDirection: "row",
    children: [
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Price Range",
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ClientNeedsPageRelayFilters.MinPrice.make, {
              refetch: refetch
            }),
            JsxRuntime.jsx(ClientNeedsPageRelayFilters.MaxPrice.make, {
              refetch: refetch
            })
          ],
          className: "flex flex-row space-x-4"
        })
      }),
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Property Types",
        children: JsxRuntime.jsx(ClientNeedsPageRelayFilters.PropertyTypes.make, {
          rentalMode: rentalMode,
          refetch: refetch
        })
      }),
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "Areas",
        children: JsxRuntime.jsx(ClientNeedsPageRelayFilters.AreasItem.make, {
          selectedAreaIds: Stdlib_Option.getOr(params.areaIds, []),
          selectedAreas: props.selectedAreas,
          setSelectedAreas: props.setSelectedAreas,
          refetch: refetch
        })
      }),
      JsxRuntime.jsx(SearchComponents.MenuItem.make, {
        title: "More Filters",
        children: JsxRuntime.jsxs(ViewStack.make, {
          children: [
            JsxRuntime.jsx(ClientNeedsPageRelayFilters.TANStatuses.make, {
              rentalMode: rentalMode,
              refetch: refetch
            }),
            JsxRuntime.jsx(ClientNeedsPageRelayFilters.Keywords.make, {
              refetch: refetch
            })
          ]
        })
      })
    ]
  });
}

let make = ClientNeedsPageRelayFiltersDesktopMenu;

exports.make = make;
/* ViewStack Not a pure module */
